var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('recipe',{attrs:{"recipe-name":_vm.recipeName,"pre-pack":_vm.prePack,"post-pack":_vm.postPack}})}
var staticRenderFns = []

export { render, staticRenderFns }